// ABOUTME: Tooltip component for electrolyte hints in metabolic profile
// ABOUTME: Displays structured content with title, description, and health effects

import { memo } from "react"
import { TooltipSection } from "./TooltipSection"
import { TooltipDivider } from "./TooltipDivider"
import { TooltipHighlight } from "./TooltipHighlight"
import { useTranslation } from "react-i18next"

interface ElectrolyteHintTooltipProps {
  title: string
  description: string
  forSport?: string
  sweatLoss?: string
  atDeficiter?: string
  inExcess?: string
}

export const ElectrolyteHintTooltip = memo(
  ({ title, description, forSport, sweatLoss, atDeficiter, inExcess }: ElectrolyteHintTooltipProps) => {
    const { t } = useTranslation()

    return (
      <div className="max-w-[280px] min-w-[220px]">
        {/* Title */}
        <div className="font-semibold text-[13px] mb-1">{title}</div>
        <TooltipDivider />

        {/* Main description */}
        <TooltipSection>
          <div className="whitespace-normal">{description}</div>
        </TooltipSection>

        {/* For sport section */}
        {forSport && (
          <TooltipSection
            title={t("hint.forSport")}
            titleColor="text-blue-500"
          >
            {forSport}
          </TooltipSection>
        )}

        {/* Sweat loss section */}
        {sweatLoss && (
          <TooltipSection
            title={t("hint.sweatLoss")}
            titleColor="text-gray-500"
          >
            {sweatLoss}
          </TooltipSection>
        )}

        {/* Deficit warning */}
        {atDeficiter && (
          <TooltipHighlight type="warning">
            <span className="font-medium">{t("hint.atDeficit")}:</span> {atDeficiter}
          </TooltipHighlight>
        )}

        {/* Excess warning */}
        {inExcess && (
          <TooltipHighlight type="error">
            <span className="font-medium">{t("hint.inExcess")}:</span> {inExcess}
          </TooltipHighlight>
        )}
      </div>
    )
  },
)

ElectrolyteHintTooltip.displayName = "ElectrolyteHintTooltip"
